import * as React from "react";
import { useState } from "react";
import EYLogoAndHelpUrl from "../EYLogoAndHelpUrl";
import { labels, currentResource } from "../../util/utils";
import ErrorSummary from "./error/ErrorSummary";
import MotifOption from "@ey/motif-react-wrapper/Option";
import MotifButton from "@ey/motif-react-wrapper/Button";
import MotifSelect from "@ey/motif-react-wrapper/Select";
import MotifFormField from "@ey/motif-react-wrapper/FormField";
import styled from "styled-components";
import { screenToRender } from "../../util/UIConstants";
import { Environment } from "../../util";
import MotifErrorMessage from "@ey/motif-react-wrapper/ErrorMessage";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import sortBy from "lodash/sortBy";

function EntitySelectLayout(props: any) {
  const {
    onEntityTypeIdChange,
    setSelectedEntityType,
    errorMessage,
    resetErrorMessage,
    setStepToRender,
    ldcVersioning,
    selectedEntityType,
  } = props;

  const [dropDownEmptyError, setDropDownEmptyError] = useState(false);
  const [entitySelected, setEntitySelected] = useState(
    currentResource.ButtonOptions.find((b) => b.id == selectedEntityType)?.label ?? ""
  );

  const onEntityDropdownSelection = (data: any) => {
    setSelectedEntityType(currentResource.ButtonOptions.find((b) => b.label == data).id);
    setEntitySelected(currentResource.ButtonOptions.find((b) => b.label == data).id);
    setDropDownEmptyError(false);
  };

  const addNewEntities = (supportedOptions: any[], newEntityIds: number[]) => {
    const newEntities = currentResource.ButtonOptions.filter((option) => newEntityIds.includes(option.id));
    return [...supportedOptions, ...newEntities];
  };

  const getSupportedEntityOptions = () => {
    let supportedOptions = currentResource.ButtonOptions;
    const entitySettings = Environment.getEntitySettings();

    let supportedEntityOptions = entitySettings.SupportedEntityBaseOptions?.split(",").map(Number);
    if (entitySettings.SupportedEntityBaseOptions) {
      // allowed all if nothing present
      supportedOptions = currentResource.ButtonOptions.filter((option) => {
        return supportedEntityOptions.includes(option.id);
      });
    }

    if (
      entitySettings?.NewEntitySupportedOptions &&
      parseFloat(entitySettings?.SupportedCanvasLDCVersionForNewEntity) <= parseFloat(ldcVersioning.datacenterversion)
    ) {
      let newEntityIds = entitySettings.NewEntitySupportedOptions.split(",").map(Number);
      supportedOptions = addNewEntities(supportedOptions, newEntityIds);
    }

    supportedOptions = sortBy(supportedOptions, ["DisplayOrder"]);

    return supportedOptions;
  };

  return (
    <GetEntityLayoutSection className="body-wrap">
      <section className="btns-wrap">
        <section className="body-section">
          <EYLogoAndHelpUrl />
          <p className="informational-text motif-body2-default-light">{labels.selectAnOperation}</p>
          <MotifFormField className="entity-select-dropdown">
            <MotifSelect
              ariaLabelledBy="select-label1"
              onChange={(e) => onEntityDropdownSelection(e)}
              value={entitySelected}
              triggerButtonProps={{
                "aria-describedby": "select-error-reactive",
              }}
              placeholder={labels.selectanitemtoedit}
              visibleOptions={5}
            >
              {getSupportedEntityOptions().map((b) => {
                return (
                  <MotifOption key={b.id} value={b.label} title={b.label}>
                    {b.label}
                  </MotifOption>
                );
              })}
            </MotifSelect>
            {dropDownEmptyError && (
              <MotifErrorMessage id="select-error-reactive">{labels.entityNotSelected}</MotifErrorMessage>
            )}
          </MotifFormField>
        </section>
        <section className="footer-wrap">
          <MotifButton
            className="back-button"
            onClick={() => setStepToRender(screenToRender.EngagementSelectLayout)}
            size="small"
            type="button"
            variant="secondary"
          >
            <MotifIcon src={IconoirArrowLeft} size="20" />
          </MotifButton>
          {/* <MotifButton
          className={`btn secondary-btn back-btn`}
          onClick={() => setStepToRender(screenToRender.EngagementSelectLayout)}
          size="medium"
          type="submit"
          variant="secondary"
        >
          <MotifIcon src={IconoirArrowLeft} />
        </MotifButton> */}
          <MotifButton
            className={"btn active-btn"}
            onClick={entitySelected ? () => onEntityTypeIdChange() : () => setDropDownEmptyError(true)}
            size="small"
            type="submit"
            variant="primary-alt"
          >
            {labels.Continue}
          </MotifButton>
        </section>
      </section>
      {errorMessage && (
        <ErrorSummary
          message={errorMessage}
          callBack={() => {
            resetErrorMessage();
          }}
        ></ErrorSummary>
      )}
    </GetEntityLayoutSection>
  );
}

export default EntitySelectLayout;

const GetEntityLayoutSection = styled.section`
  &.body-wrap {
    position: relative;
    flex-flow: column;
    display: flex;
    background-color: var(--neutrals-50);
    height: 100vh;
    overflow: auto;

    .btns-wrap {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .body-section {
        padding: var(--spacing-medium) var(--spacing-x-large) var(--spacing-x-large) var(--spacing-x-large);
        .informational-text {
          color: var(--neutrals-900);
          padding: 0;
          margin: 0;
          font-size: var(--px-12);
          margin-bottom: var(--spacing-medium);
        }
      }
      .footer-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: var(--spacing-large) var(--spacing-xx-large);
        border-top: 1px solid var(--neutrals-100);
        gap: var(--px-16);
        .back-button {
          padding: var(--px-5) !important;
          .motif-icon {
            display: flex;
            height: var(--px-20);
            width: var(--px-20);
          }
        }
      }
    }
  }
  .motif-select-input-place-holder {
    font-size: var(--px-12);
  }
  .error-wrapper {
    height: var(--px-22);
  }
  .motif-option {
    font-size: var(--px-12) !important;
    font-weight: 300 !important;
    color: var(--neutrals-900) !important;
    line-height: var(--px-18);
    padding: var(--spacing-small) var(--spacing-medium);
  }
  .motif-option > span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
  }
  .motif-select-input-text {
    font-size: var(--px-12);
    color: var(--neutrals-900);
  }
  .motif-select-options {
    max-height: unset !important;
  }
`;
